import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogTitle,
  Link,
  TextField,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { up } from '../../../theme';

export const classes = {
  root: 'root',
  pageNotFoundContainer: 'pageNotFoundContainer',
  logoIcon: 'logoIcon',
  pageNotFoundTextContainer: 'pageNotFoundTextContainer',
  pageNotFoundLogo: 'pageNotFoundLogo',
  pageNotFoundDescriptionText: 'pageNotFoundDescriptionText',
  copyRightText: 'copyRightText',
  backButtonLink: 'backButtonLink',
  backButton: 'backButton',
  conformationOkButtonLink: 'conformationOkButtonLink',
  actionButtonsContainer: 'actionButtonsContainer',
  pageNotFoundSubDescriptionText: 'pageNotFoundSubDescriptionText',
  failedChipColor: 'failedChipColor',
  completedChipColor: 'completedChipColor',
};

export const TagTextField = styled(TextField)(({ theme }) => ({
  marginTop: theme.spacing(2),
  '& .MuiInputBase-input': {
    [up('xs')]: {
      height: '6px',
    },
    [up('sm')]: {
      height: '9px',
    },
    [up('md')]: {
      height: '11px',
    },
    [up('lg')]: {
      height: '15px',
    },
    [up('xl')]: {
      height: '23px',
    },
    [up('xxl')]: {
      height: '32px',
    },
  },
}));

export const OkButtonLink = styled(Link)({
  textDecoration: 'none',
  color: 'inherit',
  display: 'block',
});

export const StatusChip = styled(Chip)(({ theme, status }) => ({
  color: '#fff',
  background:
    status === 'Failed' || status === 'Stopped' || status === 'inactive'
      ? theme.palette.colorRed.main
      : theme.palette.colorGreen.main,
  marginLeft: theme.spacing(1),
}));

export const StyledDialogTitle = styled(DialogTitle)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

export const StyledConfirmDialog = styled(Dialog)(({ theme }) => ({
  '.MuiDialog-paper': {
    [theme.breakpoints.up('sm')]: {
      minWidth: '340px',
      minHeight: '95px',
    },
    [theme.breakpoints.up('md')]: {
      minWidth: '350px',
      minHeight: '100px',
    },
    [theme.breakpoints.up('lg')]: {
      minWidth: '360px',
      minHeight: '105px',
    },
    [theme.breakpoints.up('xl')]: {
      minWidth: '370px',
      minHeight: '120px',
    },
    [theme.breakpoints.up('xxl')]: {
      minWidth: '380px',
      minHeight: '125px',
    },
  },
}));

export const StyledDialogActions = styled(DialogActions)({
  padding: '0 25px 20px 25px',
});

export const OkButton = styled(Button)(({ theme }) => ({
  boxShadow: 'none',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.secondaryWhite.main,
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondaryWhite.main,
  },
  [up('xs')]: {
    height: '25px',
    width: '65px',
  },
  [up('sm')]: {
    height: '28px',
    width: '68px',
  },
  [up('md')]: {
    height: '30px',
    width: '70px',
  },
  [up('lg')]: {
    height: '32px',
    width: '75px',
  },
  [up('xl')]: {
    height: '35px',
    width: '80px',
  },
  [up('xxl')]: {
    height: '40px',
    width: '90px',
  },
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  boxShadow: 'none',
  border: `1px solid ${theme.palette.lunarBase.semiLight}`,
  color: theme.palette.lunarBase.main,
  '&:hover': {
    border: `1px solid ${theme.palette.lunarBase.semiLight}`,
    color: theme.palette.lunarBase.main,
  },
  [up('xs')]: {
    height: '25px',
    width: '65px',
  },
  [up('sm')]: {
    height: '28px',
    width: '68px',
  },
  [up('md')]: {
    height: '30px',
    width: '70px',
  },
  [up('lg')]: {
    height: '32px',
    width: '75px',
  },
  [up('xl')]: {
    height: '35px',
    width: '80px',
  },
  [up('xxl')]: {
    height: '40px',
    width: '90px',
  },
}));

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.pageNotFoundContainer}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100vh',
    width: '100vw',
  },
  [`& .${classes.otpInput}`]: {
    [up('xs')]: {
      height: '15vh',
      width: '60vw',
    },
  },
  [`& .${classes.logoIcon}`]: {
    position: 'fixed',
    top: 20,
  },
  [`& .${classes.actionButtonsContainer}`]: {
    padding: '0 25px 20px 25px',
  },
  [`& .${classes.conformationOkButtonLink}`]: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'block',
  },
  [`& .${classes.pageNotFoundTextContainer}`]: {
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.pageNotFoundLogo}`]: {
    marginTop: '-32px',
    [up('xs')]: {
      width: '250px',
      height: '250px',
    },
    [up('sm')]: {
      width: '300px',
      height: '300px',
    },
    [up('md')]: {
      width: '350px',
      height: '350px',
    },
    [up('lg')]: {
      width: '400px',
      height: '400px',
    },
    [up('xl')]: {
      width: '450px',
      height: '450px',
    },
    [up('xxl')]: {
      width: '500px',
      height: '500px',
    },
  },
  [`& .${classes.pageNotFoundDescriptionText}`]: {
    color: theme.palette.shoeWax.darker,
    marginBottom: '5vh',
  },
  [`& .${classes.pageNotFoundSubDescriptionText}`]: {
    color: theme.palette.darkPurple.main,
    marginBottom: '14px',
    [up('xs')]: {
      fontSize: '30px',
    },
    [up('sm')]: {
      fontSize: '32px',
    },
    [up('md')]: {
      fontSize: '36px',
    },
    [up('lg')]: {
      fontSize: '40px',
    },
    [up('xl')]: {
      fontSize: '44px',
    },
    [up('xxl')]: {
      fontSize: '48px',
    },
  },
  [`& .${classes.backButtonLink}`]: {
    textDecoration: 'none',
  },
  [`& .${classes.backButton}`]: {
    padding: '10px',
    [up('xs')]: {
      width: '100px',
      height: '35px',
    },
    [up('sm')]: {
      width: '135px',
      height: '44px',
    },
    [up('md')]: {
      width: '165px',
      height: '45px',
    },
    [up('lg')]: {
      width: '150px',
      height: '45px',
    },
    [up('xl')]: {
      width: '150px',
      height: '45px',
    },
    [up('xxl')]: {
      width: '165px',
      height: '50px',
    },
  },
  [`& .${classes.copyRightText}`]: {
    color: theme.palette.secondaryWhite.dark,
    position: 'fixed',
    bottom: 10,
    width: '100vw',
    textAlign: 'center',
  },
  [`& .${classes.failedChipColor}`]: {
    background: theme.palette.colorRed.main,
  },
  [`& .${classes.completedChipColor}`]: {
    background: theme.palette.colorGreen.main,
  },
}));
